requirejs.config({
	'waitSeconds': 60,
  'urlArgs': "rjs=1.0.5",
  'baseUrl': '/user/themes/kgv/js/',
    'paths': {
    },
    map: {
      // '*' means all modules that define the specified module will get the corresponding module
      // Some modules, for some reason, say require("jQuery") instead of require("jquery")
      "*": { "jQuery": "jquery"}
    }
});

// Load the main app module to start the app
requirejs(['script.min']);